import React from 'react';
import './Dashboard.css';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();
  return (
    <div className="dashboard-container">
      <div className="dashboard-content">
        <div className="dashboard-card">
          <h2>MY GARMENTS</h2>
          <p>Upload, edit, or remove items from archives</p>
          <button type="button" onClick={() => navigate('/garments')}>MANAGE GARMENTS</button>
        </div>
        <div className="dashboard-card">
          <h2>MESSAGES</h2>
          <p>Chat with stylist and designers</p>
          <button type="button" onClick={() => navigate('/chat')}>GO TO MESSAGES</button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
